export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--L.e243f842.png";